import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import ProcessSection from "@/components/ProcessSection";
import WhyChooseUsSection from "@/components/WhyChooseUsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactSection from "@/components/ContactSection";
import SEOHelmet from "@/components/SEOHelmet";

const Index = () => {
  return (
    <>
      <SEOHelmet 
        title="Professional House Cleaning Services Connecticut"
        description="Premium residential & commercial cleaning services in Connecticut. Licensed, insured, 5-star rated. Serving Hartford, New Haven, Stamford, Bridgeport & all CT areas. Get your free estimate today!"
        keywords="house cleaning Connecticut, professional cleaning services, residential cleaners, commercial cleaning, Hartford cleaning, New Haven cleaning, Stamford cleaning, Bridgeport cleaning, CT cleaners, deep cleaning, regular cleaning"
        canonicalUrl="/"
      />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <WhyChooseUsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
    </>
  );
};

export default Index;
